import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import adicionarFiltroAgencia from '../../actions/agencia/adicionarFiltroAgencia'
import removerFiltroAgencia from '../../actions/agencia/removerFiltroAgencia'
import listarFiltrosAgencia from '../../actions/agencia/listarFiltrosAgencia'
import { FILTRO_LOCALIDADE, FILTRO_NOME, FILTRO_UF } from '../../util/filtros'
import FiltroBuscaAgencia from './FiltroBuscaAgencia';
import FiltroChaveValor from '../comum/FiltroChaveValor';

export class FiltroAgencia extends Component {
  componentDidMount () {
      this.props.listarFiltrosAgencia(this.props.empresaSelecionada.id)
  }

  adicionarFiltro (filtro) {
    this.props.adicionarFiltroAgencia(filtro)
  }

  removerFiltro (filtro) {
    this.props.removerFiltroAgencia(filtro)
  }

  render () {
    if (!this.props.nomes) {
      return <div>Carregando...</div>
    }

    return (
      <React.Fragment>
        <div className="conteudo">
          <FiltroChaveValor
              filtro={FILTRO_NOME}
              opcoes={this.props.nomes}
              filtrosAdicionados={this.props.filtrosAdicionados}
              adicionarFiltro={this.adicionarFiltro.bind(this)}
              removerFiltro={this.removerFiltro.bind(this)}
          />
          <FiltroBuscaAgencia
            filtro={FILTRO_LOCALIDADE}
            opcoes={this.props.localidades}
          />
          <FiltroBuscaAgencia
            filtro={FILTRO_UF}
            opcoes={this.props.ufs}
          />
        </div>
      </React.Fragment>
    )
  }
}

export const mapStateToProps = state => ({
  nomes: state.filtrosAgencia.nomes,
  ufs: state.filtrosAgencia.ufs,
  localidades: state.filtrosAgencia.localidades,
  filtrosAdicionados: state.filtrosAdicionadosAgencia,
  empresaSelecionada: state.empresaSelecionada

})

export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    adicionarFiltroAgencia,
    removerFiltroAgencia,
    listarFiltrosAgencia
  }, dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(FiltroAgencia)
